import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import { useWindowSize } from '../../hooks/window-size';
import { PaginationDataLayers } from './gtm-events-pagination';
import { makePaginationComponent, makePagesList, makePageLink, makePrevPage, makeNextPage, makeEtc } from './mixins';
const PaginationComponent = styled.div `
  ${() => makePaginationComponent()}
`;
const PagesList = styled.div `
  ${props => makePagesList(props)}
`;
const PageLink = styled.button `
  ${props => makePageLink(props)}
`;
const PrevPage = styled.button `
  ${() => makePrevPage()}
`;
const NextPage = styled.button `
  ${() => makeNextPage()}
`;
const Etc = styled.span `
  ${() => makeEtc()}
`;
const createPageArray = (currentPage, totalPages, isTabletPortrait) => {
    const ARRAY_MAX_LENGTH = !isTabletPortrait ? 5 : 9;
    const MIDDLE_POSITION = Math.floor(ARRAY_MAX_LENGTH / 2);
    if (!currentPage)
        return [];
    let pages = [currentPage];
    while (pages[0] > 1 && pages.length < ARRAY_MAX_LENGTH) {
        pages.unshift(pages[0] - 1);
    }
    let nextPagesCount = 0;
    while (pages[pages.length - 1] <= totalPages &&
        (pages.length < ARRAY_MAX_LENGTH || nextPagesCount < MIDDLE_POSITION)) {
        pages.push(pages[pages.length - 1] + 1);
        nextPagesCount += 1;
        if (pages.length > ARRAY_MAX_LENGTH)
            pages = pages.splice(1, ARRAY_MAX_LENGTH);
    }
    return pages;
};
export const Pagination = ({ currentPage, totalPages, goToPage, states }) => {
    const { isTabletPortrait } = useWindowSize();
    const [pages, setPages] = useState([]);
    useEffect(() => {
        setPages(createPageArray(currentPage, totalPages, isTabletPortrait));
    }, [isTabletPortrait, currentPage, totalPages]);
    useEffect(() => {
        if (states.loading)
            PaginationDataLayers.paginationOnUse(currentPage);
    }, [states]);
    return (React.createElement(PaginationComponent, null,
        React.createElement(PrevPage, { disabled: !!(currentPage <= 1) || states.loading, onClick: () => goToPage(currentPage - 2) },
            React.createElement(Icon, { name: "icon-light-caret-left", size: "20", color: "rgba(0, 0, 24, 0.48);" })),
        pages.length && pages[0] > 1 && (React.createElement(React.Fragment, null,
            React.createElement(PagesList, null,
                React.createElement(PageLink, { onClick: () => goToPage(0) }, 1)),
            React.createElement(Etc, null, "..."))),
        React.createElement(PagesList, null, pages.map(e => (React.createElement(PageLink, { key: e, disabled: states.loading, isActive: e === currentPage, onClick: () => goToPage(e - 1) },
            React.createElement("span", null, e))))),
        pages.length && pages[pages.length - 1] <= totalPages && (React.createElement(React.Fragment, null,
            React.createElement(Etc, null, "..."),
            React.createElement(PagesList, null,
                React.createElement(PageLink, { onClick: () => goToPage(totalPages) }, totalPages + 1)))),
        React.createElement(NextPage, { disabled: currentPage > totalPages || states.loading, onClick: () => goToPage(currentPage) },
            React.createElement(Icon, { name: "icon-light-caret-right", size: "20", color: "rgba(0, 0, 24, 0.48);" }))));
};
